import { render, staticRenderFns } from "./BoxInputs.vue?vue&type=template&id=5bba9057&"
import script from "./BoxInputs.vue?vue&type=script&lang=ts&"
export * from "./BoxInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports